import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import StaffMobile from "../mobile/admin/StaffMobile";
import GestionStaff from "./GestionStaff";

export default function ResponsiveGestionStaff(props) {
  return useIsMobile() ? <StaffMobile {...props} /> : <GestionStaff {...props} />;
}
